import React from "react";
import "../css/DirectorsMessageComponent.scss";
import BannerComponent from "./BannerComponent";
import GalleryBannerImage from '../assets/WhatsApp Image 2024-09-23 at 4.44.24 PM 1.png';
import DirectorsImage from '../assets/director-portrait.jpg';

const DirectorsMessageComponent = () => {
    return (
        <div className="director-container">
            <BannerComponent
                title="Director's Message"
                image={GalleryBannerImage}
                description="A word from the heart of our school"
                buttonInformation={<></>}
            />

            <div className="director-message-section">
                <div className="page-width director-message-layout">
                    <div className="director-portrait-container">
                        <img className="director-portrait" alt="Director, The Honeyrock School" src={DirectorsImage} />
                    </div>

                    <div className="director-message-text">
                        <header className="director-header">Director's Message</header>
                        <p className="director-subheader">Welcome to The Honeyrock School!</p>

                        <p>
                            <span className="drop-cap">I</span>t is my absolute privilege to welcome you to our website. Whether you are a current family, a prospective parent searching for the right educational home for your child, or a visitor learning about our mission, we are blessed to have you here.
                        </p>

                        <p>
                            At The Honeyrock School, we believe that God is the center focus of everything we do. Our approach to education is rooted in the truth that academic excellence and spiritual growth go hand-in-hand.
                        </p>

                        <p>
                            We are dedicated to nurturing not only the minds of our students but also their hearts, guiding them to discover their God-given purpose and to lead with integrity, faith, and compassion.
                        </p>

                        <p>
                            We firmly believe that raising the next generation requires a strong partnership. The collaboration between our dedicated educators, our motivated pupils, and our supportive families is what makes our community truly special and vibrant. Together, we are building a foundation where children can grow in wisdom, stature, and favor.
                        </p>

                        <p>
                            As we look forward to the future, we remain committed to providing high-quality learning experiences, fostering holistic well-being, and ensuring that our school remains a safe, loving environment where Christ's love is evident in our daily walk.
                        </p>

                        <p className="director-thanks">
                            Thank you for visiting our digital home.
                        </p>

                        <ul className="director-info">
                            <li>Best Regards,</li>
                            <li className="bold">Ps. Aduke Obey</li>
                            <li className="bold">Director, The Honeyrock School</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DirectorsMessageComponent;
